<div class="container">

  <app-header-dialog [iconName]="'people_outline'">
    Associado
  </app-header-dialog>

  <div class="content">

    <div style="padding: 10px; margin: 5px 0 5px 0; border: solid 1px silver;">
      <b>
        {{ member.data.name }}
      </b>
    </div>
    <br>

    <div [innerHTML]='member.data.text'
      style="inline-size: 550px; overflow-wrap: break-word; padding: 10px; margin: 5px 0 5px 0; border: solid 1px silver;">
    </div>
    <br>

    <div style="padding: 10px; margin: 5px 0 5px 0; border: solid 1px silver;">
      <div style="width: 300px; margin: auto;">
        <img [src]="member.data.image" style="width: 100%;">
      </div>
    </div>
    <br>

    <div [innerHTML]='member.urlUpdate'
      style="inline-size: 550px; overflow-wrap: break-word; padding: 10px; margin: 5px 0 5px 0;  border: solid 1px silver;">
    </div>
    <br>

    <!--
    <div style="padding: 10px; margin: 5px 0 5px 0;  border: solid 1px silver; text-align: center;">
      <a mat-button (click)="updateLink(member)" style="color:rgba(0,0,0,.6);">
        <b>
          Atualizar link
        </b>
      </a>
    </div>
    <br>
    -->

  </div>


</div>